/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import { connect } from "react-redux";

import BasicDetails from "./basicDetails";
import PaymentDetails from "./paymentDetails";
import AddressDetails from "./addressDetails";
import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";

import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Grid from "@mui/material/Grid";
import { withTranslation } from "react-i18next";

import Card from "@mui/material/Card";
import Button from "../../../component/button";
import CardContent from "@mui/material/CardContent";

import Loader from "../../../component/loader";

import PaymentIcon from "@mui/icons-material/Payment";
import Breadcrumb from "../../../component/breadcrumb";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import classes from "./customer.module.css";
import CustomerDetails from "./customerDetails";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CardPaymentIcon from "react-payment-icons";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import actionTypes from "../../../store/actions";
import Box from "@mui/material/Box";
import Draggable from "react-draggable";
import { Paper, TableContainer } from "@mui/material";
import { Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import { withStyles } from '@mui/styles';

// const styles = {
//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '60vw',
//     },
// };
class Profile extends Component {
  state = {
    tabValue: 0,
    display: false,
    billingDetails: {},
    shippingDetails: {},
    bread: [{ title: this.props.t("MY_PROFILE"), url: "/myProfile" }],
    addressDetails: [],

    //payments
    paymentMethodList: [],
    eftAccountList: [],
    creditCardList: [],

    //basicDetails
    email: "",
    firstName: "",
    lastName: "",
    emailMechId: "",
    mobilePhone: "",
    officePhone: "",
    mobilePhoneMechId: "",
    officePhoneMechId: "",
    userName: "",
    isManaged: "",

    //billing address array for paymnent
    billingAddressList: [],
    customersEmployeeList: [],

    profileData: {},
    loading: false,

    paymentMethod: {},
    openDialog: false,
    loggedInUser: {},
    modules: {},
  };

  componentDidMount() {
    this.getMyProfile();
    
    if (this.props.setSelectCallback) {
      this.props.setSelectCallback(() => this.onNext());
    }
  }

  getMyProfile = () => {
    this.setState({ loading: true });
    var modules = JSON.parse(localStorage.getItem("modules"));
    this.setState({ modules: modules ? modules : {} });
    let creditCardList = [];
    let eftAccountList = [];
    // this.setState({ loading: true })
    //get the customer profile

    let customerId = "";
    // if (this.props.loggedInUserType === "ECOMMERCE_CUSTOMER") { } else {
    if (
      this.props.screen === "manageCustomer" ||
      this.props.screen === "checkout"
    ) {
      customerId = this.props.isChild
        ? this.props.childItemDetails.partyId
        : this.props.customerDetails.partyId;
    }
    // }
    // if (this.props.customerDetails) {
    //     console.log('check============', this.props.childItemDetails)
    // }
    let jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = this.props.parentTenantId;
    }
    BusApiCall(
      "GET",
      `${constants.busV4Url}/myProfile?customerId=${customerId}`,
      jsonData,
    )
      .then((res) => {
        var userRoles = JSON.parse(localStorage.getItem("roles"));
        var loggedInUser = {
          userName: userRoles.data.loggedInUser.userName,
          userId: userRoles.data.loggedInUser.userId,
          email: userRoles.data.loggedInUser.email,
        };
        if (this.props.isChild) {
          eftAccountList = [];
          creditCardList = [];
          this.props.customerDetails.paymentMethods.map((method, i) => {
            if (method.routingNumber) {
              eftAccountList.push({ ...method });
            } else if (method.cardNumber) {
              creditCardList.push({ ...method });
            }
          });
          this.setState(
            {
              profileData: res.data,
              eftAccountList: eftAccountList,
              creditCardList: creditCardList,
              loggedInUser,
              display: false,
            },
            () => {
              this.setState({ display: true, loading: false });
            },
          );
          // let payment = this.props.customerDetails.paymentMethod ? JSON.parse(this.props.customerDetails.paymentMethod) : {};
          // eftAccountList = payment.eftAccounts ? payment.eftAccounts : [];
          // creditCardList = payment.creditCards ? payment.creditCards : [];
          // this.setState({
          //     profileData: res.data,
          //     eftAccountList: eftAccountList,
          //     creditCardList: creditCardList,
          // }, () => {
          //     this.setState({ display: true, loading: false })
          // })
        } else {
          this.setState({ billingAddressList: res.data.billing });
          res.data.paymentMethods.map((method, i) => {
            if (method.routingNumber) {
              eftAccountList.push({ ...method });
            } else if (method.cardNumber) {
              creditCardList.push({ ...method });
            }
          });

          this.setState(
            {
              firstName: res.data.firstName,
              lastName: res.data.lastName,

              email: res.data.email,
              mobilePhone: res.data.mobilePhone,
              officePhone: res.data.officePhone,

              userName: res.data.username,
              isManaged: res.data.isManaged ? res.data.isManaged : false,

              accountName: res.data.accountName,

              billingDetails: res.data.billing,
              shippingDetails: res.data.shipping,
              addressDetails: res.data.billing,
              paymentMethodList: res.data.paymentMethods,
              emailMechId: res.data.emailMechId,
              mobilePhoneMechId: res.data.mobilePhoneMechId,
              officePhoneMechId: res.data.officePhoneMechId,
              customersEmployeeList: res.data.customersEmployeeList,
              profileData: res.data,
            },
            () => {
              this.state.profileData.createdByUser = this.state.profileData
                .createdByUser
                ? this.state.profileData.createdByUser
                : "";
              this.setState(
                {
                  eftAccountList: eftAccountList,
                  creditCardList: creditCardList,
                  loggedInUser,
                  display: false,
                },
                () => {
                  this.setState({ display: true, loading: false });
                },
              );
            },
          );
        }

        // Set payment data for checkout flow
        let paymentMethod = {};
        if (this.props.selectedPaymentMethod) {
          paymentMethod = this.props.selectedPaymentMethod;
        } else {
          for (var i = 0; i < eftAccountList.length; i++) {
            if (eftAccountList[i].primary) {
              paymentMethod.eftAccount = [eftAccountList[i]];
            }
          }
          for (var i = 0; i < creditCardList.length; i++) {
            if (creditCardList[i].primary) {
              paymentMethod.creditCards = [creditCardList[i]];
            }
          }
        }
        this.setState({
          paymentMethod,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  //for the component tabs
  handleChange = (event, newValue) => {
    this.setState(
      {
        display: false,
        tabValue: newValue,
      },
      () => {
        let creditCardList = [];
        let eftAccountList = [];
        this.setState({ loading: true });
        //get the customer profile

        let customerId = "";
        if (this.props.customerDetails) {
          customerId = this.props.customerDetails.partyId;
        }
        let jsonData = {};
        if (
          this.props.providerType === "SOLUTION_PROVIDER" &&
          this.props.solutionList.length > 0
        ) {
          jsonData.tenantId = this.props.solutionList[0].providerId;
        }
        BusApiCall(
          "GET",
          `${constants.busV4Url}/myProfile?customerId=${customerId}`,
          jsonData,
        ).then((res) => {
          this.setState({ billingAddressList: res.data.billing });
          res.data.paymentMethods.map((method, i) => {
            if (method.routingNumber) {
              eftAccountList.push({ ...method });
            } else if (method.cardNumber) {
              creditCardList.push({ ...method });
            }
          });

          let addressDetails = [];
          if (this.state.tabValue === 1) {
            this.setState(
              {
                addressDetails: this.state.shippingDetails,
              },
              () => {
                this.setState({ display: true });
              },
            );
          } else if (this.state.tabValue === 2) {
            this.setState(
              {
                addressDetails: this.state.billingDetails,
              },
              () => {
                this.setState({ display: true });
              },
            );
          }

          this.setState(
            {
              firstName: res.data.firstName,
              lastName: res.data.lastName,

              email: res.data.email,
              mobilePhone: res.data.mobilePhone,
              officePhone: res.data.officePhone,

              billingDetails: res.data.billing,
              shippingDetails: res.data.shipping,
              // addressDetails: this.state.billingDetails,
              paymentMethodList: res.data.paymentMethods,
            },
            () => {
              this.setState(
                {
                  eftAccountList: eftAccountList,
                  creditCardList: creditCardList,
                },
                () => {
                  this.setState({ display: true, loading: false });
                },
              );
            },
          );
        });
      },
    );
  };

  updateProfileData = (data) => {
    let profileData = { ...this.state.profileData, ...data };
    this.setState({
      profileData: profileData,
    });
  };

  choosePaymentMethod = () => {
    this.setState({
      openDialog: true,
    });
  };

  handleClose = () => {
    this.setState({
      openDialog: false,
    });
  };

  onNext = () => {
    if (
      !this.props.customerDetails.partyId &&
      !this.props.childItemDetails.id
    ) {
      this.props.setErrorMessage(this.props.t("CUSTOMER_NOT_SELECTED"), false);
    } else {
      this.props.goNext(this.state.paymentMethod, this.state.profileData);
    }
  };

  closeDialog = () => {
    this.props.closeDialog();
  };

  chooseExistingPaymentMethod = (method, value) => {
    var paymentMethod = {};
    if (method.routingNumber) {
      paymentMethod.eftAccount = [method];
    } else if (method.cardNumber) {
      paymentMethod.creditCards = [method];
    } else {
      paymentMethod.invoice = true;
    }
    this.setState({
      paymentMethod: paymentMethod,
      openDialog: false,
    });
  };

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  //render
  render() {
    const { t } = this.props;
    const mainStyle = {
      maxWidth: "auto",
      margin: "auto",
      padding: "1rem",
      // paddingTop: '0',
      // paddingRight: '0',
      backgroundColor: "transparent",
    };
    const { classes: jssClasses } = this.props;
    return (
      <div style={{ position: "relative", width: "-webkit-fill-available" }}>
        <div
          style={
            this.props.screen == "manageCustomer" ||
            this.props.screen == "checkout"
              ? mainStyle
              : { maxWidth: "1300px", minHeight: "500px", padding: "1rem" }
          }
        >
          <div>
            {this.props.screen == "manageCustomer" ||
            this.props.screen == "checkout" ? (
              this.state.display && (
                <>
                  <CustomerDetails
                    // profile data
                    profileData={this.state.profileData}
                    isManaged={this.state.isManaged}
                    updateProfileData={this.updateProfileData}
                    // Billing address data
                    customerDetails={this.props.customerDetails}
                    addressDetails={this.state.addressDetails}
                    // Payment details data
                    creditCardList={this.state.creditCardList}
                    eftAccountList={this.state.eftAccountList}
                    paymentMethodList={this.state.paymentMethodList}
                    billingAddressList={this.state.billingAddressList}
                    addChildItem={this.props.addChildItem}
                    editChildItem={this.props.editChildItem}
                    getCustomersHierarchy={this.props.getCustomersHierarchy}
                    screen={this.props.screen}
                    isChild={this.props.isChild}
                    userPerms={this.props.permissions}
                    loggedInUserType={this.props.loggedInUserType}
                    loggedInUserId={this.props.loggedInUserId}
                    manageCustomerRequired={this.props.manageCustomerRequired}
                    parentTenantId={this.props.parentTenantId}
                    reloadCustomerData={this.getMyProfile}
                    isTaskMode={this.props.isTaskMode}
                    newLeadOrCustomer={this.props.newLeadOrCustomer}
                    promoteLead={this.props.promoteLead}
                    sectorsList={this.props.sectorsList}
                  />
                  {this.props.screen == "checkout" && (
                    <div style={{ marginTop: "1rem" }}>
                      {this.state.modules.module_payment === "enabled" && (
                        <Card
                          variant="outlined"
                          style={{ borderRadius: "8px" }}
                        >
                          <CardContent>
                            {/* <TableContainer> */}
                            {/* <TableContainer> */}
                            <Table className={classes.noBorder}>
                              <TableHead>
                                <TableRow>
                                  <TableCell>
                                    <h3
                                      style={{ marginTop: 0, marginBottom: 0 }}
                                    >
                                      {t("PAYMENT_METHOD")}
                                    </h3>
                                  </TableCell>
                                  <TableCell align="right">
                                    <Button
                                      onClick={() => {
                                        this.choosePaymentMethod("payment");
                                      }}
                                      className={"buttonSecondary"}
                                    >
                                      {t("CHANGE")}
                                    </Button>
                                    {/* <span className={classes.linkSpan} style={{ color: this.props.tenantData.color, marginLeft: '13px' }} onClick={() => { this.choosePaymentMethod("payment") }}>{t('CHANGE')}</span> */}
                                    {/* <span className={classes.chooseExistingDialog} style={{ color: this.props.tenantData.color, marginLeft: '13px' }} onClick={() => { addNewPaymentMethod("CREDIT_CARD") }}>Add Card</span>
                                                                <span className={classes.chooseExistingDialog} style={{ color: this.props.tenantData.color, marginLeft: '13px' }} onClick={() => { addNewPaymentMethod("EFT_ACCOUNT") }}>Add Bank Account</span> */}
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {/* If default method is credit card */}
                                {this.state.paymentMethod.creditCards &&
                                  this.state.paymentMethod.creditCards.length >
                                    0 && (
                                    <TableRow>
                                      <TableCell colSpan={2}>
                                        <Grid container spacing={3}>
                                          <Grid
                                            item
                                            className="text-title"
                                            size={{
                                              xs: 12,
                                            }}
                                          >
                                            {this.state.paymentMethod
                                              .creditCards[0].cardType ===
                                            "CCT_VISA" ? (
                                              <>
                                                <CardPaymentIcon
                                                  id="visa"
                                                  className={"paymentIcon"}
                                                />
                                              </>
                                            ) : this.state.paymentMethod
                                                .creditCards[0].cardType ===
                                              "CCT_MASTERCARD" ? (
                                              <>
                                                <CardPaymentIcon
                                                  id="mastercard"
                                                  className={"paymentIcon"}
                                                />
                                              </>
                                            ) : (
                                              this.state.paymentMethod
                                                .creditCards[0].cardType ===
                                                "CCT_AMERICANEXPRESS" && (
                                                <>
                                                  <CardPaymentIcon
                                                    id="amex"
                                                    className={"paymentIcon"}
                                                  />
                                                </>
                                              )
                                            )}
                                            <span style={{ marginTop: "6px" }}>
                                              {" "}
                                              {t("ENDING_IN")}{" "}
                                              {this.state.paymentMethod.creditCards[0].cardNumber.slice(
                                                this.state.paymentMethod
                                                  .creditCards[0].cardNumber
                                                  .length - 4,
                                              )}{" "}
                                            </span>
                                            <br />
                                            {
                                              this.state.paymentMethod
                                                .creditCards[0].street1
                                            }
                                            ,&nbsp;
                                            {this.state.paymentMethod
                                              .creditCards[0].street2 && (
                                              <>
                                                {
                                                  this.state.paymentMethod
                                                    .creditCards[0].street2
                                                }
                                                ,&nbsp;{" "}
                                              </>
                                            )}
                                            {
                                              this.state.paymentMethod
                                                .creditCards[0].city
                                            }
                                            ,&nbsp;
                                            {
                                              this.state.paymentMethod
                                                .creditCards[0].state
                                            }
                                            ,&nbsp;
                                            {
                                              this.state.paymentMethod
                                                .creditCards[0].country
                                            }
                                            ,&nbsp;
                                            {
                                              this.state.paymentMethod
                                                .creditCards[0].zip
                                            }
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                    </TableRow>
                                  )}
                                {/* If default method is eft account */}
                                {this.state.paymentMethod.eftAccount &&
                                  this.state.paymentMethod.eftAccount.length >
                                    0 && (
                                    <TableRow>
                                      <TableCell colSpan={2}>
                                        <Grid container spacing={3}>
                                          <Grid
                                            item
                                            className="text-title"
                                            size={{
                                              xs: 12,
                                            }}
                                          >
                                            {
                                              this.state.paymentMethod
                                                .eftAccount[0].bankName
                                            }
                                            <span style={{ marginTop: "6px" }}>
                                              {" "}
                                              {t("ENDING_IN")}{" "}
                                              {this.state.paymentMethod.eftAccount[0].accountNumber.slice(
                                                this.state.paymentMethod
                                                  .eftAccount[0].accountNumber
                                                  .length - 4,
                                              )}{" "}
                                            </span>
                                            <br />
                                            {
                                              this.state.paymentMethod
                                                .eftAccount[0].street1
                                            }
                                            ,&nbsp;
                                            {this.state.paymentMethod
                                              .eftAccount[0].street2 && (
                                              <>
                                                {
                                                  this.state.paymentMethod
                                                    .eftAccount[0].street2
                                                }
                                                ,&nbsp;{" "}
                                              </>
                                            )}
                                            {
                                              this.state.paymentMethod
                                                .eftAccount[0].city
                                            }
                                            ,&nbsp;
                                            {
                                              this.state.paymentMethod
                                                .eftAccount[0].state
                                            }
                                            ,&nbsp;
                                            {
                                              this.state.paymentMethod
                                                .eftAccount[0].country
                                            }
                                            ,&nbsp;
                                            {
                                              this.state.paymentMethod
                                                .eftAccount[0].zip
                                            }
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                    </TableRow>
                                  )}
                                {(!this.state.paymentMethod.creditCards ||
                                  this.state.paymentMethod.creditCards.length ==
                                    0) &&
                                  (!this.state.paymentMethod.eftAccount ||
                                    this.state.paymentMethod.eftAccount
                                      .length == 0) && (
                                    <TableRow>
                                      <TableCell colSpan={2}>
                                        <Grid container spacing={3}>
                                          <Grid
                                            item
                                            className="text-title"
                                            size={{
                                              xs: 12,
                                            }}
                                          >
                                            {t("INVOICE_ME")}
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                    </TableRow>
                                  )}
                                {/* {(!this.state.paymentMethod.creditCards || this.state.paymentMethod.creditCards.length == 0) &&
                                                            (!this.state.paymentMethod.eftAccount || this.state.paymentMethod.eftAccount.length == 0) &&
                                                            (!this.state.paymentMethod.invoice) &&
                                                            <TableRow >
                                                                <TableCell colSpan={2} align="center">No payment method selected.</TableCell>
                                                            </TableRow>
                                                        } */}
                              </TableBody>
                            </Table>
                            {/* </TableContainer> */}
                          </CardContent>
                        </Card>
                      )}
                      {this.props.subScreen === "product" ? (
                        <>
                        {!this.props.setSelectCallback &&
                        <div style={{ marginTop: "1rem", textAlign: "right" }}>
                          <Button
                            className="buttonSecondary"
                            onClick={() => {
                              this.closeDialog();
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            {t("CANCEL")}
                          </Button>
                          <Button
                            onClick={() => {
                              this.onNext();
                            }}
                          >
                            {t("SELECT")}
                          </Button>
                        </div>
                }
                        </>
                      ) : (
                        <div style={{ marginTop: "1rem", textAlign: "right" }}>
                          <Button
                            onClick={() => {
                              this.props.back(this.props.stage);
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            {t("BACK")}
                          </Button>
                          <Button
                            onClick={() => {
                              this.onNext();
                            }}
                          >
                            {t("NEXT")}
                          </Button>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )
            ) : (
              <>
                {(this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                  this.props.loggedInUserType === "ECOMMERCE_ADMIN") && (
                  <>
                    <div
                      className={"newContentWrapper checkPageContentWrapper"}
                    >
                      <div className={"breadcrumbWrapper"}>
                        <div className={"breadcrumbContent"}>
                          <Grid container>
                            <Grid
                              item
                              size={{
                                xs: 12,
                              }}
                            >
                              <Breadcrumb list={this.state.bread} />
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    </div>
                    <div style={{ height: "75px" }}></div>
                  </>
                )}
                <Grid container spacing={3}>
                  <Grid
                    item
                    size={{
                      xs: 1,
                    }}
                  ></Grid>
                  <Grid
                    item
                    size={{
                      xs: 10,
                    }}
                  >
                    <Box display="flex" justifyContent="center" width="100%">
                      <Tabs
                        // textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        indicatorColor="primary"
                        value={this.state.tabValue}
                        onChange={this.handleChange}
                        className={classes.createPackageTabs}
                      >
                        <Tab
                          label={t("GENERAL_INFORMATION")}
                          icon={<ContactPhoneIcon />}
                        />
                        <Tab
                          label={t("SHIPPING_ADDRESS")}
                          icon={<LocalShippingIcon />}
                        />
                        <Tab
                          label={t("BILLING_ADDRESS")}
                          icon={<ReceiptIcon />}
                        />
                        <Tab
                          label={t("PAYMENT_DETAILS")}
                          icon={<PaymentIcon />}
                        />
                      </Tabs>
                    </Box>
                    <Box paddingTop={3} /> {/*Space added*/}
                    {this.state.tabValue === 0 && this.state.display && (
                      <BasicDetails
                        screen="myProfile"
                        tabValue={this.state.tabValue}
                        profileData={this.state.profileData}
                        updateProfileData={this.updateProfileData}
                        loggedInUser={this.state.loggedInUser}
                      />
                    )}
                    {(this.state.tabValue === 1 || this.state.tabValue === 2) &&
                      this.state.display && (
                        <AddressDetails
                          screen="myProfile"
                          tabValue={this.state.tabValue}
                          customerDetails={this.props.customerDetails}
                          addressDetails={this.state.addressDetails}
                          reloadCustomerData={this.getMyProfile}
                        />
                      )}
                    {this.state.tabValue === 3 && this.state.display && (
                      <PaymentDetails
                        tabValue={this.state.tabValue}
                        creditCardList={this.state.creditCardList}
                        eftAccountList={this.state.eftAccountList}
                        customerDetails={this.props.customerDetails}
                        paymentMethodList={this.state.paymentMethodList}
                        billingAddressList={this.state.billingAddressList}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 1,
                    }}
                  ></Grid>
                </Grid>
              </>
            )}
            <Loader loading={this.state.loading} />
          </div>

          {this.state.openDialog && (
            <Dialog
              disableScrollLock={true}
              fullWidth={true}
              PaperComponent={this.draggableDialogPaper}
              maxWidth={"sm"}
              open={this.state.openDialog}
              aria-labelledby="customized-dialog-title"
              PaperProps={
                {
                  // className: jssClasses.resizablePaper
                }
              }
            >
              <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span
                    style={{ display: "inline-flex", alignItems: "center" }}
                  >
                    {t("CHOOSE_A_PAYMENT_METHOD")}
                  </span>
                  <Tooltip title={t("CLOSE")}>
                    <IconButton
                      onTouchStart={() => this.handleClose(false)}
                      onClick={() => this.handleClose(false)}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </DialogTitle>
              <DialogContent dividers>
                <PaymentDetails
                  tabValue="3"
                  screen="checkout"
                  eftAccountList={this.state.eftAccountList}
                  creditCardList={this.state.creditCardList}
                  // customerDetails={this.props.customerDetails}
                  chooseExistingCustomerDetail={
                    this.chooseExistingPaymentMethod
                  }
                />
              </DialogContent>
              {/* <DialogActions>
                                <Button onClick={event => this.handleClose(false)} color="primary">{t('CANCEL')}</Button>
                            </DialogActions> */}
            </Dialog>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tenantData: state.auth.tenantData,
    loggedInUserType: state.auth.userLoginType,
    providerType: state.auth.providerType,
    solutionList: state.cart.solutions,
    permissions: state.auth.userPerms,
    ecommerceCustData: state.auth.ecommerceCustData,
    loggedInUserId: state.auth.loggedInUserId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(Profile));
